module.exports = __webpack_public_path__ + "img/dp-faq.8cca3b0a.jpg";